module.exports = __webpack_public_path__ + "static/img/anxun12.d7d3cd53.png";